<template>
  <div class="container-fluid full-height d-flex justify-content-center align-items-center">
    <div class="text-center">
      <div class="row" style="height: 30px;"></div>
      <div class="message-banner-success" v-if="messageType == 'SUCCESS'">
          <span class="message-text" v-html="messageText"></span>
          <button class="close-button" onclick="closeBanner()">×</button>
      </div> 
      <div class="message-banner-error" v-if="messageType == 'ERROR'">
          <span class="message-text" v-html="messageText"></span>
          <button class="close-button" onclick="closeBanner()">×</button>
      </div> 
      <div class="row" style="height: 30px;"></div>
      <div class="row">
          <div class="col">
              <input id="passCode" type="text" style="width:50%;" v-on:keyup.enter="onEnterPassCode">
          </div>       
      </div>
      <div class="row" style="height: 150px;"></div>   
      <div class="row" v-if="viewType == 'CHECK-IN'">
        <div class="col">
          <button type="button" class="btn btn-warning" style="width:250px; height:180px;font-size:40px;font-weight:bold;" @click="onCheckIn">CHECK-IN</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'

const VIEW_ENTER_PASSCODE = 'ENTER-PASSCODE'
const VIEW_CHECKIN = 'CHECK-IN'
const MESSAGE_TYPE_SUCCESS = 'SUCCESS'
const MESSAGE_TYPE_ERROR = 'ERROR'

export default {
  name: 'ManualCheckInOutView',
  data() {
    return {
      viewType: '',
      projectId: 0,
      gateId: '',
      passCodeId: '',
      paymentMethodName: '',
      messageText: '',
      baseAPIUrl: '',
      isTapIn: false
    }
  },
  computed: {
  },
  created() {
    this.gateId = this.$route.params.gateId
    this.projectId = this.$route.params.projectId
    this.baseAPIUrl = this.$route.params.baseAPIUrl
    this.callback = this.$route.params.callback
  },
  mounted() {
    document.getElementById('passCode').focus()
    this.viewType = VIEW_ENTER_PASSCODE
    this.messageType = MESSAGE_TYPE_SUCCESS
    this.messageText = 'Please scan the barcode ...'
  },
  methods: {
    onEnterPassCode() {
      let me = this

      if (this.isTapIn) {
        document.getElementById('passCode').value = ''
        return
      }

      let passCode = document.getElementById('passCode').value
      if (passCode === '') {
        return
      }

      this.isTapIn = true

      this.passCodeId = passCode.split('|')[0]
      this.paymentMethodName = passCode.split('|')[1]
      var reqData = {
        id: '',
        gate_id: this.gateId,
        gate_name: '',
        process_date: '',
        pass_code_id: this.passCodeId,
        status: '',
        payment_method_name: this.paymentMethodName,
        project_id: this.projectId
      }

      api
        .request('Gate', 'post', this.baseAPIUrl + '/TapIn', reqData)
        .then(response => {
          if (response.data.entity.status === 'INVALID') {
            this.messageText = response.data.returnMessage.join('<br>')
            this.messageType = MESSAGE_TYPE_ERROR

            this.isTapIn = false
          } else {
            me.viewType = VIEW_CHECKIN
            this.messageText = 'TAP-IN done. Please continue click CHECK-IN'
            this.messageType = MESSAGE_TYPE_SUCCESS
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          this.messageText = message
          this.messageType = MESSAGE_TYPE_ERROR
          this.isTapIn = false
        })

      document.getElementById('passCode').value = ''
      document.getElementById('passCode').focus()
    },
    onCheckIn() {
      let me = this

      var reqData = {
        id: '',
        gate_id: this.gateId,
        gate_name: '',
        process_date: '',
        pass_code_id: this.passCodeId,
        status: '',
        payment_method_name: this.paymentMethodName,
        project_id: this.projectId
      }

      api
        .request('Gate', 'post', this.baseAPIUrl + '/CheckIn', reqData)
        .then(response => {
          if (response.data.returnStatus) {
            me.viewType = VIEW_ENTER_PASSCODE
            this.messageText = response.data.returnMessage.join('<br>')
            this.messageType = MESSAGE_TYPE_SUCCESS
          } else {
            this.messageText = response.data.returnMessage.join('<br>')
            this.messageType = MESSAGE_TYPE_ERROR
          }

          return response.data.returnStatus
        })
        .then(isSuccess => {
          if (isSuccess) {
            this.releasePassCodeQueue(reqData)
            this.isTapIn = false
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          this.messageText = message
          this.messageType = MESSAGE_TYPE_ERROR
        })

      document.getElementById('passCode').focus()
    },
    releasePassCodeQueue(reqData) {
      api
        .request('Gate', 'post', this.baseAPIUrl + '/ReleaseQueue', reqData)
        .then(response => {
          console.log(response.data.returnMessage.join('<br>'))
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          console.log(message)
        })
    }
  }
}
</script>

<style scoped>
.message-banner-success {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #2fdd1c;
    color: white;
    padding: 15px 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;
}

.message-banner-error {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #c01111;
    color: white;
    padding: 15px 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;
}

.message-text {
    flex: 1;
    font-size: 30px;
}

.close-button {
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
}

.close-button:hover {
    color: #ccc;
}
</style>



// WEBPACK FOOTER //
// ManualCheckInOut.vue?3c0acad3